import * as React from 'react';

import { renderToggleButton } from '@fluentui/react-button';

import { RibbonToggleButtonInternalProps } from '../RibbonToggleButton.props';
import { useRibbonToggleButton } from './useRibbonToggleButton';
import { useRibbonToggleButtonStyles } from './useRibbonToggleButtonStyles';

/**
 * Define a styled `RibbonToggleButton` using the `useRibbonToggleButton` hook.
 */
export const RibbonToggleButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonToggleButtonInternalProps>((props, ref) => {
    const state = useRibbonToggleButton(props, ref);

    // Apply styling
    useRibbonToggleButtonStyles(state);

    return renderToggleButton(state);
  })
);

RibbonToggleButton.displayName = 'next/RibbonToggleButton';
